import type { Asset, AssetTypeIdentifier, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { AssetTypeIdentifiersListItem } from "./AssetTypeIdentifiersListItem"

interface AssetTypeIdentifiersListProps {
	asset: Stored<Asset>
	assetTypeIdentifiers: Stored<AssetTypeIdentifier>[]
}

export const AssetTypeIdentifiersList = memo<AssetTypeIdentifiersListProps>((props) => {
	const { asset, assetTypeIdentifiers } = props

	return (
		<div className="flex flex-wrap gap-2">
			{assetTypeIdentifiers.map((assetTypeIdentifier) => {
				return (
					<AssetTypeIdentifiersListItem
						key={assetTypeIdentifier.uuid}
						asset={asset}
						assetTypeIdentifier={assetTypeIdentifier}
					/>
				)
			})}
		</div>
	)
})
AssetTypeIdentifiersList.displayName = "AssetTypeIdentifiersList"
